import constants from '@/constants';
import { request } from './request';

const msBaseUrl = constants.apiMSBaseUrl;

export type MsResponse = {
  data: any;
  message: string;
};

export default {
  msBaseUrl,

  msGet: request('GET', msBaseUrl),
  msPost: request('POST', msBaseUrl),
  msPut: request('PUT', msBaseUrl),
  msPatch: request('PATCH', msBaseUrl),
  msDel: request('DELETE', msBaseUrl),

  // SME MS requests
  smeGet: request('GET', msBaseUrl, true),
  smePost: request('POST', msBaseUrl, true),
  smePut: request('PUT', msBaseUrl, true),
  smePatch: request('PATCH', msBaseUrl, true),
  smeDel: request('DELETE', msBaseUrl, true),
};
